import { useAuth } from "../../hooks/use-auth";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useState } from "react";
import { Link } from "wouter";

const LoginForm = () => {
  const { loginMutation } = useAuth();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    loginMutation.mutate(formData);
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="username" className="!text-gray-900 dark:!text-gray-900">Username</Label>
          <Input
            id="username"
            name="username"
            placeholder="Enter your username"
            required
            value={formData.username}
            onChange={handleChange}
            className="!bg-white dark:!bg-white !border-gray-200 dark:!border-gray-200 !text-gray-900 dark:!text-gray-900 placeholder:!text-gray-500 dark:placeholder:!text-gray-500 focus:!ring-blue-500 dark:focus:!ring-blue-500 focus:!border-blue-500 dark:focus:!border-blue-500"
          />
        </div>
        
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="!text-gray-900 dark:!text-gray-900">Password</Label>
            <Link 
              href="/forgot-password"
              className="text-sm text-blue-600 dark:text-blue-600 hover:text-blue-500 dark:hover:text-blue-500 hover:underline"
            >
              Forgot your password?
            </Link>
          </div>
          <Input
            id="password"
            name="password"
            type="password"
            placeholder="Enter your password"
            required
            value={formData.password}
            onChange={handleChange}
            className="!bg-white dark:!bg-white !border-gray-200 dark:!border-gray-200 !text-gray-900 dark:!text-gray-900 placeholder:!text-gray-500 dark:placeholder:!text-gray-500 focus:!ring-blue-500 dark:focus:!ring-blue-500 focus:!border-blue-500 dark:focus:!border-blue-500"
          />
        </div>
        
        <Button 
          type="submit" 
          className="w-full !bg-blue-600 hover:!bg-blue-700 !text-white dark:!bg-blue-600 dark:hover:!bg-blue-700 dark:!text-white py-3 !border-0 dark:!border-0"
          disabled={loginMutation.isPending}
        >
          {loginMutation.isPending ? "Logging in..." : "Login"}
        </Button>
        
        {loginMutation.isError && (
          <p className="text-sm text-red-600 dark:text-red-600">
            {(loginMutation.error as Error)?.message || "Invalid username or password."}
          </p>
        )}
      </form>
    </div>
  );
};

export default LoginForm; 